import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { CardsComponent } from "@components/cards/cards.component";
import { GruppWithFragor } from "~app/features/virkeskop/models/checklist-models";
import { KontraktChecklistFragaComponent } from "../kontrakt-checklist-fraga/kontrakt-checklist-fraga.component";

@Component({
    selector: "rask-kontrakt-checklist-grupp",
    templateUrl: "./kontrakt-checklist-grupp.component.html",
    styleUrl: "./kontrakt-checklist-grupp.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardsComponent,
        KontraktChecklistFragaComponent
    ]
})
export class KontraktChecklistGruppComponent {
    @Input() grupp: GruppWithFragor;
}
